/*
 * @Author: LiuChuanQi
 * @Date: 2022-09-08 15:12:30
 * @LastEditTime: 2022-11-15 18:14:02
 * @LastEditors: LiuChuanQi
 * @Description: 
 * @FilePath: \speedtest-bigdata-v2\src\utils\webUtil.js
 * 
 */
import request from '@/utils/request'
/*防抖*/
export const debounce = function (fn, delay, immediate) {
  let timer = null
  delay = delay || 500
  return function () {
    const context = this
    const args = arguments
    if (timer) {
      clearTimeout(timer)
    }
    if (immediate) {
      if (!timer) {
        fn.apply(context, args)
      }
      timer = setTimeout(function () {
        timer = null
      }, delay)
    } else {
      timer = setTimeout(function () {
        timer = fn.apply(context, args)
      }, delay)
    }
  }
}

//获取当前年月日
export const getDate = function () {
  var date = new Date()
  var year = date.getFullYear()   //  返回的是年份
  var month = date.getMonth() + 1  //  返回的月份上个月的月份，记得+1才是当月
  var dates = date.getDate()    //  返回的是几号
  var day = date.getDay()       //  周一返回的是1，周六是6，但是周日是0
  var hour = date.getHours()     // 时
  var minutes = date.getMinutes()  // 分
  var seconds = date.getSeconds()  //秒
  // 给一位数的数据前面加 “0”
  if (month >= 1 && month <= 9) {
    month = "0" + month
  }
  if (dates >= 0 && dates <= 9) {
    dates = "0" + dates
  }
  if (hour >= 0 && hour <= 9) {
    hour = "0" + hour
  }
  if (minutes >= 0 && minutes <= 9) {
    minutes = "0" + minutes
  }
  if (seconds >= 0 && seconds <= 9) {
    seconds = "0" + seconds
  }
  year = year + ''
  month = month + ''
  dates = dates + ''
  day = day + ''
  hour = hour + ''
  minutes = minutes + ''
  seconds = seconds + ''
  return {
    year, month, dates, day, hour, minutes, seconds
  }
}


// 获取num 天前的日期
export const getDaysAgo = function (num) {
  let myDate = new Date()
  let lw = new Date(myDate - 1000 * 60 * 60 * 24 * num) //最后一个数字30可改，30天的意思
  let lastY = lw.getFullYear()
  let lastM = lw.getMonth() + 1
  let lastD = lw.getDate()
  let startData =
    lastY +
    "-" +
    (lastM < 10 ? "0" + lastM : lastM) +
    "-" +
    (lastD < 10 ? "0" + lastD : lastD) //三十天之前日期
  lastM = lastM < 10 ? "0" + lastM : lastM
  lastD = lastD < 10 ? "0" + lastD : lastD
  return { startData, lastY, lastM, lastD }
}
//批量获取指定城市坐标
export const getCoordinate = function () {
  const citys = ['北京', '天津', '石家庄', '济南', '太原', '郑州', '合肥', '西安', '南京', '上海', '杭州', '武汉', '成都', '重庆', '银川', '长春', '沈阳', '呼和浩特', '南昌', '长沙', '昆明', '广州', '南宁', '福州', '哈尔滨', '青岛', '大连', '苏州', '宁波', '深圳', '中山']
  let sendArray = []
  //此处的key是webapi key 而非js apikey
  citys.forEach((element, index) => {
    let url = `https://restapi.amap.com/v3/config/district?keywords=${element}&subdistrict=0&key=75def7f6791372f40cbb233be9387fbd`
    request.get(url).then((res) => {
      if (res.status == '1' && res.districts && res.districts.length) {
        let cityItem = res.districts[0].center.split(',')
        let obj = { city: element, point: cityItem }
        sendArray.push(obj)
        if (index == citys.length - 1) {
          console.log(sendArray)
        }
      }
    })
  })
}

// 获取两个日期之间间隔的天数
export const getIntervalDays = function (startDate, endDate) {
  const sDate = Date.parse(startDate)
  const eDate = Date.parse(endDate)
  if (sDate > eDate) {
    return 0
  }
  if (sDate === eDate) {
    return 1
  }
  const days = (eDate - sDate) / (1 * 24 * 60 * 60 * 1000)
  return days
}

//获取当前月的天数
export const monthGetDate = function (year, month) {
  var d = new Date(year, month, 0)
  return d.getDate()
}

//requestAnimationFrame替代定时器
export const requestInterval = function (fn, delay) {
  var requestAnimFrame = (function () {
    return window.requestAnimationFrame || function (callback, element) {
      window.setTimeout(callback, 1000 / 60)
    }
  })(),
    start = new Date().getTime(),
    handle = {}
  function loop () {
    handle.value = requestAnimFrame(loop)
    var current = new Date().getTime(),
      delta = current - start
    if (delta >= delay) {
      fn.call()
      start = new Date().getTime()
    }
  }
  handle.value = requestAnimFrame(loop)
  return handle
}


export const requestAnimationTimeout = (callback, delay = 0) => {
  const start = Date.now()
  function timeout () {
    if (Date.now() - start >= delay) {
      callback.call()
    } else {
      obj.id = dataSetTimeout(timeout)
    }
  }

  const obj = {
    id: dataSetTimeout(timeout)
  }

  return obj
}

export const changeURLArg = function (url, arg, arg_val) {
  var pattern = arg + '=([^&]*)'
  var replaceText = arg + '=' + arg_val
  if (url.match(pattern)) {
    var tmp = '/(' + arg + '=)([^&]*)/gi'
    tmp = url.replace(eval(tmp), replaceText)
    return tmp
  } else {
    if (url.match('[\?]')) {
      return url + '&' + replaceText
    } else {
      return url + '?' + replaceText
    }
  }
}

export const getCaption = function (obj, text) {
  if (obj.includes(text)) {
    let index = obj.lastIndexOf(text) + text.length - 1
    obj = obj.substring(index + 1, obj.length)
    return obj
  } else {
    return ''
  }
}

/**
* 获取url里的参数
* @param arg 参数名
* @returns
*/
export const regExpQuery = function (url, name) {
  // //从索引1处开始截取，即舍弃掉"？"
  let search = getCaption(url, '?')
  //通过正则表达式匹配，例如 ： a=10&b=70&password=90
  //注意看下面的正则表达式:
  //（一）、(^|&) 匹配的是开始或者是&，如上a前面的空字符开始，和b前面的&符号
  //（二）、${name} 是一个模板字符串，匹配的是我们传递进来的name
  //（三）、([^&]*)第二个分组指定匹配的字符不能是&的一个或多个字符，如上，匹配的是10,70,90，但是仅这样还不行，还没有结尾
  //（四）、(&|$)第四个分组指定我们查询参数的结尾，是以&结尾或者是结尾，没有这个分组，我们的参数结不了尾。 比如a=10这里以&结尾，匹配到10；b=70匹配到70，以&结尾；password=90匹配到是是字符的结尾，后面没有内容，所以匹配到90

  let reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`)
  let result = search.match(reg)
  if (result == null) {
    return null
  } else {
    //这里之所以是索引2，是因为上面的正则表达式中我们真正要返回的查询参数值是第2对小括号中的内容，索引0处返回的是整个匹配的正则表达式对象
    return result[2]
  }

}


